<div>
  <div class="grid gap-4">
    @if (apigeeIsLoading()) {
      <div class="bg-primary-container flex h-[247px] w-[365px] items-center justify-center">
        <bolt-waiting-indicator class="h-20 w-20" minimal></bolt-waiting-indicator>
      </div>
    } @else {
      <div class="bg-primary-container grid gap-2 p-6">
        <div class="flex justify-between font-medium">
          <div>Monthly price</div>
          <div>{{ axiomQuoteState().monthlyPrice | currency }}</div>
        </div>
        <div class="flex justify-between">
          <div>One-time enrollment fee</div>
          <div>{{ axiomQuoteState().enrollmentFee | currency }}</div>
        </div>

        <bolt-divider class="mt-4"></bolt-divider>
        <div>
          <div class="flex justify-between text-[24px] font-medium">
            <div>Amount due</div>
            <div>{{ (axiomQuoteState().monthlyPrice ?? 0) + (axiomQuoteState().enrollmentFee ?? 0) | currency }}</div>
          </div>
          <div class="flex justify-end text-[12px] font-medium">+tax</div>
        </div>
        <div>
          <p>Full refund, less any paid claims, if canceled during the 20-day* trial period.</p>
          <p>*30 days in DC, HI, IL and TX</p>
        </div>
      </div>
    }
  </div>
  <bolt-checkbox
    class="pt-8"
    (change)="toggleEmailToClient()"
    [checked]="axiomQuoteState().emailToClient"
    [disabled]="
      apigeeIsLoading() || qfStore.notificationState()?.notification?.type === 'error' || axiomQuoteState().emailSent
    "
    >Email Plan Overview with quote to client</bolt-checkbox
  >

  <!-- Navigation -->
  <div class="grid gap-4 pt-10">
    @if (hasEquipmentBreakdown) {
      <div class="text-[12px] font-medium">
        By clicking the Continue button, you acknowledge Equipment Breakdown has been removed from this policy.
      </div>
    }
    <bolt-button
      (click)="handleForward()"
      (keyDown.enter)="handleForward()"
      [disabled]="apigeeIsLoading() || qfStore.notificationState()?.notification?.type === 'error'"
      class="w-full"
      type="solid"
    >
      Continue
    </bolt-button>

    <bolt-button
      type="ghost"
      class="w-full"
      (click)="handleBackward()"
      (keydown)="handleBackward()"
      [disabled]="apigeeIsLoading()"
      >Back</bolt-button
    >
  </div>
</div>
